export class TelemetryData {
    constructor(knownHiragana: number, knownKatakana: number, totalTurns: number, sessionIdentifier: string) {
        this.knownHiragana = knownHiragana;
        this.knownKatakana = knownKatakana;
        this.totalTurns = totalTurns;
        this.sessionIdentifier = sessionIdentifier;
        // @ts-ignore
        this.location = window.location.href
    }

    knownHiragana: number;
    knownKatakana: number;
    totalTurns: number;
    sessionIdentifier: string;
    location: string;
}


// WEBPACK FOOTER //
// ./src/models/TelemetryData.ts